// import moment from "moment";
import axios from "axios";
import { LeadBudgetRange, url } from "../../src/Values/constants";
import {
  showSnackbarAction,
  setFilterObject
} from "../Redux/actions";
import { convertToFilterString } from "../Values/utils";
import axiosHandler from "./axiosHandler";

export const fetchApiData = async (
    organization_id: string,
    setProjects: (data: any[]) => void,
    authToken: string,
    setCount: (data: any) => void,
    filters: any,
    sort: any,
    limit: any,
    page: any,
    searchQuery: any,
    setLoad: (load: boolean) => void,
    oldData: any,
    isFinished: any,
    setIsFinished: (load: boolean) => void,
    apiDaysFilter: any,
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number,
    tempIsFinished?: boolean,
  ) => {
    try {
      if (isFinished === true && tempIsFinished !== false) {
        return;
      }
      let stringFilters: string = convertToFilterString(filters);
      let records = localPageSize ? localPageSize : limit;
      let apiData: any = {
        organization_id: organization_id,
        sort:  Object.keys(sort).length === 0
        ? { created_at: "-1" }
        : sort,
        filters: stringFilters,
        page: localPage ? localPage : page + 1,
        limit: localPageSize ? localPageSize : limit,
        search: searchQuery,
        apiDaysFilter
      };
      // setLoad(true);
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.get(url + '/apiData/fetchAll', {
        params: apiData,
      });
      let apiPanelData = res.data.data.apiData;
      let apiPanelCount = res.data.data.apiCount;
      // console.log("data res api tokens", res.data.data, isFinished)
      // if ((page.currentValue < page.previousValue) || oldData.length ) {
      //   return;
      // }
      if (apiPanelData.length < records) {
        setIsFinished(true);
      }
  
      setCount(apiPanelCount);
      setLoad(false);
      if (paginate && oldData) {
        let newData = [...oldData, ...apiPanelData];
        setProjects(newData);
        setLoad(false);
      } else {
        setProjects(apiPanelData);
        setLoad(false);
      }
      // dispatcher(
      //   showSnackbarAction(res.data.message, "success")
      // );
      // setLoad(false);
      // close();
      // editClose();
    } catch (error: any) {
      // dispatcher(
      //   showSnackbarAction(error.response.data.message, "error")
      // );
      // setLoad(false);
      setLoad(false);
    }
  };

  export const fetchApiDataFilterValues = async (
    organization_id: string,
    authToken: string,
    dispatcher: any,
  ) => {
    try {
  
      let apiData = {
        organization_id
      }
      // console.log("amaklsls", apiData)
      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.get(url + '/apiData/filterValues', { params: apiData });
      let data: any = res.data.data[0];
      dispatcher(setFilterObject({ ...data }));
    } catch (error: any) {
      dispatcher(setFilterObject({}))
    }
  };

  export const formatLeadBudget = (item:any) => {
    if (!isNaN(item)) {
      const match = LeadBudgetRange.find((b:any) => b.value === item);
      if (match) {
        return match.displayName;
      }
    }
    return item;
  };



